// Copyright (C) 2023-2026 Skylark Drones

import apiInstance from '@/config'

/**
 * Get tip of day
 *
 * @param {Object} filters Data to filter tips
 * @param {"android"|"web"} filters.client For which client tip is for
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export function getTipsOfTheDay(filters) {
  const params = {}

  if (filters) {
    params.filters = filters
  }

  return apiInstance.http.get(`/tips/tip_of_the_day`, { params })
}

/**
 * Upvote tip of the day
 *
 * @param {String} tipId Id of the tip
 * @returns
 */
export function upvoteTipsOfTheDay(tipId) {
  return apiInstance.http.patch(`/tips/${tipId}/upvote`)
}

/**
 * Downvote tip of the day
 *
 * @param {String} tipId Id of the tip
 * @returns
 */
export function downTipsOfTheDay(tipId) {
  return apiInstance.http.patch(`/tips/${tipId}/downvote`)
}
